import { motion } from "framer-motion";
import { Building2, Briefcase, Globe2, ArrowUpRight } from "lucide-react";

const STAGES = [
  {
    icon: Building2,
    eyebrow: "Large & Leading Pharma",
    title: "Unlock ROI from your neglected mature & tail-end portfolio.",
    body: "Our Delta Field Force acts as your dedicated 'Team B' for consolidation and penetration — without the cost of a parallel sales force.",
    cta: "Optimize Mature & Tail-End Portfolio",
  },
  {
    icon: Briefcase,
    eyebrow: "SMEs & Mid-Size Healthcare",
    title: "Access professional field force from day one.",
    body: "Nationwide HCP & chemist networks plus full marketing execution — without building expensive in-house teams.",
    cta: "Turnkey Growth Engine",
  },
  {
    icon: Globe2,
    eyebrow: "Multinational Companies",
    title: "Enter India's extra-urban markets with confidence.",
    body: "Local expertise, established networks, and execution capability across 300+ market HQs.",
    cta: "India Market Entry",
  },
];

export default function GrowthStages() {
  return (
    <section className="py-20 md:py-32 bg-slate-50 border-y border-slate-200" data-testid="growth-stages-section">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 mb-14 md:mb-20 items-end">
          <div className="md:col-span-5">
            <div className="text-xs font-bold uppercase tracking-[0.2em] text-teal-700 mb-3">
              Built for Every Growth Stage
            </div>
            <h2 className="font-display text-4xl md:text-5xl lg:text-6xl font-extrabold leading-[1.02] text-slate-900">
              One model. <br />
              <span className="font-editorial italic font-medium text-slate-700">Three audiences.</span>
            </h2>
          </div>
          <div className="md:col-span-6 md:col-start-7">
            <p className="text-base md:text-lg text-slate-600 leading-relaxed">
              From leading MNC pharma houses to ambitious SMEs — Medstry's model is engineered for outcomes
              at every scale, with economics designed for the realities of Indian extra-urban markets.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {STAGES.map((s, i) => {
            const Icon = s.icon;
            return (
              <motion.a
                key={s.eyebrow}
                href="/#contact"
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-80px" }}
                transition={{ duration: 0.5, delay: i * 0.08 }}
                data-testid={`stage-card-${i}`}
                className="group relative bg-white border border-slate-200 p-8 hover:border-slate-900 transition-colors duration-300 flex flex-col"
              >
                <div className="flex items-center justify-between mb-10">
                  <Icon className="h-7 w-7 text-teal-600" strokeWidth={1.5} />
                  <ArrowUpRight className="h-5 w-5 text-slate-400 group-hover:text-slate-900 group-hover:-translate-y-0.5 group-hover:translate-x-0.5 transition-all" />
                </div>
                <div className="text-[11px] font-bold uppercase tracking-[0.18em] text-slate-500 mb-3">
                  {s.eyebrow}
                </div>
                <h3 className="font-display text-2xl md:text-[28px] leading-[1.15] font-bold text-slate-900 mb-4">
                  {s.title}
                </h3>
                <p className="text-slate-600 text-[15px] leading-relaxed mb-8 flex-1">{s.body}</p>
                <div className="text-sm font-semibold text-slate-900 inline-flex items-center gap-1.5 border-t border-slate-200 pt-4">
                  {s.cta} <ArrowUpRight className="h-4 w-4" />
                </div>
              </motion.a>
            );
          })}
        </div>
      </div>
    </section>
  );
}
